/**
 *
 * @class
 */
function NetworkPlaceLauncher() {
    this.launchResource = function(resource) {
        var newWin = window.open("np.html#VFSDirectoryList0?path=" + encodeURIComponent("/"));
        newWin.CudaLaunch = newWin.CudaLaunch || {};
        newWin.CudaLaunch.serverConfiguration = CudaLaunch.serverConfiguration;
        newWin.CudaLaunch.NP = {
            vfsId : resource.id,
            title : resource.name,
            lang : CudaLaunch.clientConfiguration.getLanguage(),
            favourite : resource.favourite
        };

        newWin.addEventListener("unload", CudaLaunch.models.resources.refresh);
    };
}

module.exports = NetworkPlaceLauncher;


//////////////////
// WEBPACK FOOTER
// ./network_places/NetworkPlaceLauncher.js
// module id = 110
// module chunks = 0